import React, { FC } from 'react';
import { Text } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';

interface NCFileDetailsNCFilePerformanceUtilizationProps {}

const NCFileDetailsNCFilePerformanceUtilization: FC<NCFileDetailsNCFilePerformanceUtilizationProps> = () => {
  return (
    <DetailsPageWrapper title="NC File">
      <Text>NCFileDetailsNCFilePerformanceUtilization</Text>
    </DetailsPageWrapper>
  );
};

export { NCFileDetailsNCFilePerformanceUtilization };
